import {
  Component, EventEmitter, OnDestroy, OnInit, Input, ViewChild, Output,
  OnChanges,
  SimpleChanges,
  SimpleChange
} from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { CartService } from '../services/cart.service';
import { AppMessageService } from '../../app-message.service';
import { ConfigurationService } from '../services/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from '../services/cache.service';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import orderBy from 'lodash-es/orderBy';
import remove from 'lodash-es/remove';
import { StoreConfig } from '../interfaces/store-config.interface';
import { Member } from '../interfaces/member.interface';
import { CacheKey } from '../constants/cachekey.constants';
import { Cart } from '../models/cart.model';
import { CartTypes } from '../enums/cart-types.enum';
import { Item } from '../models/item.model';
import { Product } from '../../products/interfaces/product.interface';
import { CurrencyPipe } from '../../common/pipes/currency-format.pipe';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { UserTitleType } from '../enums/user-title-type.enum';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { trigger, transition, style, animate } from '@angular/animations';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { SSO } from '../../sso/sso.constants';
import { SlimScrollDirective } from '../../common/directives/slimscroll.directive';
import { CartSummary } from '../interfaces/cart-summary.interface';
import { AppModalDirective } from '../../common/directives/app-modal.directive';
import { Ng2DeviceService } from 'ng2-device-detector';
import { MemberLevel } from '../enums/member-level.enum';
import { ActiveSessionService } from '../services/active-session.service';
import { DisplayPriceConfig } from '../interfaces/display-price-config.interface';
import { MemberDisplayPriceConfigService } from '../services/member-display-price-config.service';
import { PortalDisplayPage } from '../enums/portal-display-page.enum';
@Component({
  selector: 'app-minicart, [app-minicart]',
  templateUrl: '../templates/template1/views/mini-cart.component.html',
  styleUrls: ['../templates/template1/themes/default/less/mini-cart.less'],
  animations: [
    trigger('fadeInOut',
      [
        transition(
          ':enter', [
            style({ transform: 'translateY(-10%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateY(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateY(-10%)', opacity: 0 }))
          ]
        )]
    )
  ]
})
export class MiniCartComponent implements OnInit, OnDestroy, OnChanges {
  miniCartSubscription: Subscription;
  store: StoreConfig;
  storeId: number;
  language: string;
  shoppingCart: Cart;
  canShowMiniCart = false;
  cartProducts: Product[];
  memberTitle = MemberLevel;
  memberTitleId: number = MemberLevel.RETAIL;
  isoCountryCode: string;
  languageCode: string;
  cookieBannerValue: any;
  isModalShown: boolean;
  itemToRemove: Product;
  isOpen = false;
  showCartOnHover = false;
  // wqa
  // tslint:disable-next-line:no-input-rename
  @Input('minicart') isMinicart = false;
  // tslint:disable-next-line:no-input-rename
  @Input('show') show = false;
  @Output() showChange = new EventEmitter();
  isMiniCartHover = false;
  currentSwipperIndex = 0;
  removeItem: boolean;
  clearBag: boolean;
  @Input() isMiniCartClicked = false;
  touchStarted: boolean;
  minicartTimer: any;
  isTouchDevice: boolean;
  displayPriceConfig: DisplayPriceConfig;
  userInfo: Member;
  @ViewChild('confirmModal', { static: false }) public confirmModal: AppModalDirective;
  @ViewChild('slimScrollDiv', { static: false }) slimScrollDiv: SlimScrollDirective;
  timer: any;
  public prodSlideConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    touchRatio: 0.2,
    autoplay: true,
    navigation: false
  };
  orderItemsCount;

  constructor(
    private _commonService: CommonService,
    private _cartService: CartService,
    private _appMessageService: AppMessageService,
    private _configurationService: ConfigurationService,
    private _cacheService: CacheService,
    private cookieService: CookieService,
    private _deviceDetector: Ng2DeviceService,
    private _activeSessionService: ActiveSessionService,
    private memberDisplayPriceConfigService: MemberDisplayPriceConfigService
  ) {
    this.checkDeviceInfo();
  }

  ngOnInit() {
    this.getInitializeConfig();
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.cookieBannerValue = this._cacheService.get(CacheKey.CookieBanner);
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.memberTitleId = this._activeSessionService.getMemberTitleId();    // All Categories
    // cartItems will be updated on each addToCart Event.
    this.getCartSessionInfo();
    this._appMessageService.getOpenCart().subscribe((isOpen: boolean) => {
      this.isOpen = isOpen;
    });
    // register touchmove for all the elements in body
    document.addEventListener('touchmove', function (e: TouchEvent) {
      // stop body scroll, when the minicart is in open
      if (this.show) {
        e.preventDefault();
      }
    }.bind(this), { passive: false });
    this.displayPriceConfig = this.memberDisplayPriceConfigService
    .getDisplayPriceConfig(this._commonService.prepareMemberDisplayConfigInfo(PortalDisplayPage.ShoppingCart, this.store.taxInclusive,
      this.userInfo, false, this.store.taxInclusive));
 }
  /**
   * touchmove listerner for minicart container
   * @param {TouchEvent} e
   * @returns {void}
   * @memberof MiniCartComponent
   */
  miniCartTouchMove(e: TouchEvent): void {
    if (this.show) {
      const target: any = e.target;
      const minicartContainer = $(e.currentTarget);
      const hasChild = minicartContainer.has(target).length > 0;
      // stop the body scroll, when we scroll the minicart
      if (hasChild) {
        // stop the body scroll, when we dont have a scroll in mincart
        if (minicartContainer.height() === minicartContainer.prop('scrollHeight')) {
          e.preventDefault();
          return;
        }
        e.stopPropagation();
      }
    }
  }
  /**
       * Check whether the its Desktop or touch devices
       * to prevent the custom slimscroll being added in touch devices
       * @memberof SlimScrollDirective
       */
  checkDeviceInfo(): void {
    if (!this._deviceDetector.isDesktop()) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = false;
    }
  }

  /**
   * get store configuration
   * @param
   */
  getInitializeConfig(): void {
    const result: StoreConfig = this._configurationService.getStoreData();
    if (result != null) {
      this.store = result;
      this.storeId = this.store.id;
      this.loadMemberCartItemsBasedOnCartType();
    }
  }

  /**
  * @description on mouse leave close the mini cart
  * @date 2018-08-20
  * @memberof MiniCartComponent
  */
  miniCartMouseLeave(): void {
    this.isMiniCartClicked = false;
    clearTimeout(this.minicartTimer);
    if (!this.isMiniCartHover && this.show) {
      const duration = this.isTouchDevice ? 3500 : 2000;
      this.minicartTimer = setTimeout(() => {
        if (!this.isMiniCartHover && this.show && !this.isMiniCartClicked) {
          this.showMiniCart(false);
        }
      }, duration);
    }
  }

  /**
   * @returns void
   */
  private getCartSessionInfo(): void {
    this.miniCartSubscription = this._appMessageService.getMiniCart()
      .subscribe((cartSessionId: any) => {
        this.getCartItems(null, false);
      });
    const miniCartViewSubscription = this._appMessageService.getMiniCartView()
      .subscribe((value: any) => {
        if (value) {
          this.showMiniCart(true);
          clearTimeout(this.timer);
          setTimeout(() => {
            const offsetTop = document.getElementById('Item-' + value).offsetTop;
            if (this.slimScrollDiv) {
              if (!this.slimScrollDiv._disableDirective) {
                this.slimScrollDiv.scrollContent(offsetTop, false, true);
              } else {
                this.slimScrollDiv._me.scrollTop = offsetTop;
              }
            }
          }, 200);
          this.timer = setTimeout(() => {
            if (!this.isMiniCartHover && !this.touchStarted) {
              this.showMiniCart(false);
            }
          }, 2000);
        }
      });
    this.miniCartSubscription.add(miniCartViewSubscription);
  }

  ngOnChanges(changes: SimpleChanges) {
    const isMiniCartShow: SimpleChange = changes.show;
    if (isMiniCartShow && isMiniCartShow.currentValue) {
      this.isCartEmpty();
    }
  }

  /**
   * check cart items is emtpy
   * @returns void
   */
  isCartEmpty(): void {
    if (!this.shoppingCart || this.shoppingCart.items.length < 1 || this.shoppingCart.itemsCount < 1) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.show = false;
        this.showChange.emit(false);
      }, 2000);
    }
  }

  /**
   * @description load member cart items based on the cart types
   * @date 2018-09-03
   * @private
   * @memberof MiniCartComponent
   */
  private loadMemberCartItemsBasedOnCartType(): void {
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    let cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    const clearCart = this._cacheService.getCookieValue(CacheKey.ClearCart);
    if ((userInfo && cartSessionInfo && cartSessionInfo.memberId
      && userInfo.memberId !== cartSessionInfo.memberId)
      || !userInfo && cartSessionInfo && cartSessionInfo.memberId) {
      this._cacheService.remove(CacheKey.CartSessionInfo);
      this._cacheService.remove(CacheKey.WishListSession);
      this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
      this._cacheService.removeCookieValue(CacheKey.ClearCart);
      this._cacheService.remove(CacheKey.CartSummary);
      cartSessionInfo = null;
    }
    const cartSessionId = this._cacheService.getCookieValue(CacheKey.CartSessionGuid);
    if ((userInfo && !cartSessionInfo) || (userInfo && cartSessionInfo)) {
      this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
      this.getMemberCartSummary(userInfo.memberId);
      this.getCartItemsByMemberAndCartTypeId(userInfo.memberId, CartTypes.OrderCart);
      this.getCartItemsByMemberAndCartTypeId(userInfo.memberId, CartTypes.WishlistCart);
    } else if (cartSessionId) {
      this._cartService.getCartSessionInfo(cartSessionId, CartTypes.OrderCart)
        .subscribe((cart: Cart) => {
          if (cart) {
            if (cart.memberId && !userInfo) {
              this.clearCartSession();
            } else {
              this.getCartItems(cart, true, true);
            }
          }
        }, (error: any) => {
          this.clearCartSession();
        });
    } else {
      this.getCartItems(null, true);
    }
  }

  /**
   * To remove the cart session and cart session Id from cache
   * @returns void
   */
  clearCartSession(): void {
    this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
    this._cacheService.remove(CacheKey.CartSessionInfo);
    this._cacheService.remove(CacheKey.CartSummary);
  }

  /**
   * @description get the Cart Items from the order cart
   * @date 2018-09-03
   * @private
   * @param {Member} userInfo
   * @param {Cart[]} cart
   * @memberof MiniCartComponent
   */
  private getOrderCart(orderCart: Cart): void {
    if (orderCart && orderCart.items && orderCart.items.length >= 0) {
      this.mergeCartItems(orderCart);
    } else {
      this.mergeCartItems(null);
    }
  }

  /**
   * @description get wishlist cart items list
   * @date 2018-09-03
   * @private
   * @param {Cart[]} cart
   * @memberof MiniCartComponent
   */
  private getWishlistCart(wishListCart: Cart): void {
    if (wishListCart && wishListCart.items && wishListCart.items.length >= 0) {
      this.getWishlistProducts(wishListCart);
    } else {
      this._cacheService.remove(CacheKey.WishListSession);
    }
  }

  /**
   * @description get cart items based on the member id and cart type
   * @date 2018-09-03
   * @private
   * @param {number} memberId
   * @param {CartTypes} cartTypeId
   * @returns {Cart[]}
   * @memberof MiniCartComponent
   */
  private getCartItemsByMemberAndCartTypeId(memberId: number, cartTypeId: CartTypes): void {
    this._cartService.getCartItemsByMemberIdAndCartType(memberId, cartTypeId)
      .subscribe((response: Cart) => {
        if (response && response.sessionGuid) {
          if (CartTypes.OrderCart === cartTypeId) {
            this.getOrderCart(response);
          } else if (CartTypes.WishlistCart === cartTypeId) {
            this.getWishlistCart(response);
          }
        } else {
          const userInfo = this._cacheService.get(CacheKey.UserInfo);
          if (userInfo && CartTypes.OrderCart === cartTypeId) {
            const cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
            if (cartSessionInfo && cartSessionInfo.items) {
              this._cartService.saveCart(cartSessionInfo.items, CartTypes.OrderCart).subscribe((res: any) => {
                if (res) {
                  this.getCartItems(res, true, true);
                  const cartSession = {
                    sessionInfo: res.sessionGuid,
                    reloadMemberCart: false
                  };
                  this._appMessageService.setMiniCart(cartSession);
                }
              });
            }
          }
        }
      });
  }

  /**
   * @description get Member Cart SUmmary
   * @date 2018-09-03
   * @private
   * @param {number} memberId
   * @param {CartTypes} cartTypeId
   * @returns {Cart[]}
   * @memberof MiniCartComponent
   */
  private getMemberCartSummary(memberId: number): void {
    this._cartService.getMemberCartSummary(memberId)
      .subscribe((response: CartSummary[]) => {
        if (response) {
          this._cacheService.set(CacheKey.CartSummary, response);
          const orderCartSummary = response.find(cart =>
            cart.cartTypeId === CartTypes.OrderCart);
          this.orderItemsCount = (orderCartSummary && orderCartSummary.itemCount > 0) ? orderCartSummary.itemCount : null;
          this._appMessageService.setWishListItems();
        }
      });
  }

  /**
 * to display wishlist products
 * @param  {number} productId
 * @param  {number} storeid
 */
  getWishlistProducts(wishListCart: Cart) {
    let productIds: number[] = [];
    if (wishListCart && wishListCart.items && wishListCart.items.length > 0) {
      productIds = wishListCart.items.map((x: any) => x.productId);
      if (productIds && productIds.length > 0) {
        this._commonService
          .getProductsByIds(productIds, this.language, this.storeId)
          .subscribe(wishListProducts => {
            if (wishListProducts && wishListProducts.length > 0) {
              wishListProducts.map(x => {
                x.productQuantity = 1;
              });
              const unAvailableCartItems: any = [];
              wishListCart.items.forEach(x => {
                const cartItem: Product = wishListProducts.filter(y => y.id === x.productId)[0];
                if (!cartItem) {
                  if (x.productId) {
                    unAvailableCartItems.push(x);
                  }
                  wishListCart.items.splice(wishListCart.items.indexOf(x), 1);
                }
              });
              wishListCart = this._cartService.reloadCart(this._cartService.reloadCartSession(wishListProducts, wishListCart));
              this._cacheService.set(CacheKey.WishListSession, wishListCart);
              this._appMessageService.setWishListItems();
            } else {
              wishListCart.items = [];
              this._cacheService.set(CacheKey.WishListSession, wishListCart);
              this._appMessageService.setWishListItems();
            }
          }, error => {

          });
      } else if (wishListCart && wishListCart.sessionGuid) {
        this._cacheService.set(CacheKey.WishListSession, wishListCart);
      }
    } else if (wishListCart && wishListCart.sessionGuid) {
      this._cacheService.set(CacheKey.WishListSession, wishListCart);
    }
  }

  /**
  * @param  {Cart} orderCart?
  * @returns void
  */
  private mergeCartItems(orderCart?: Cart): void {
    const cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    if (cartSessionInfo && cartSessionInfo.items &&
      cartSessionInfo.items.length > 0 && !cartSessionInfo.memberId) {
      if (orderCart) {
        orderCart.items.forEach(x => {
          const cartItem: Item = cartSessionInfo.items.find(y => y.productId === x.productId);
          if (cartItem) {
            x.quantity = x.quantity + cartItem.quantity;
            cartSessionInfo.items.splice(cartSessionInfo.items.indexOf(cartItem), 1);
          }
        });
        let cartItems: any = [];
        if (cartSessionInfo.items.length > 0) {
          cartItems = cartSessionInfo.items.map(function (x) {
            return {
              productId: x.productId, quantity: x.quantity
            };
          });
        }
        orderCart.items = orderCart.items.concat(cartItems);
      } else {
        orderCart = cartSessionInfo;
      }
    }
    if (orderCart) {
      this.getCartItems(orderCart, true, true);
    } else {
      this.shoppingCart = this._cartService.reloadCart(null);
      this._cacheService.remove(CacheKey.CartSessionInfo);
      this._appMessageService.setCartItemsCount(0);
    }
  }

  /**
   * load cart items based on cart session guid
   * @returns void
   */
  getCartItems(orderCart: Cart, removeInValid: boolean, reLoadCart?: boolean): void {
    const cartSession: Cart = orderCart || this._cacheService.get(CacheKey.CartSessionInfo);
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (cartSession && cartSession.items) {
      if (cartSession && cartSession.sessionGuid && !userInfo) {
        this._cacheService.setCookieValue(CacheKey.CartSessionGuid, cartSession.sessionGuid);
        this._cacheService.removeCookieValue(CacheKey.ClearCart);
      }
      if (cartSession.items.length > 0 && reLoadCart) {
        if (userInfo) {
          this._cacheService.setCookieValue(CacheKey.hasCartItems, true);
        }
        cartSession.items = orderBy(cartSession.items, ['id'], ['asc']);
        const productIds = cartSession.items.map(x => x.productId);
        this._commonService.getProductsByIds(productIds, this.language, this.storeId)
          .subscribe((response: Product[]) => {
            if (response && response.length > 0) {
              response.map(x => {
                x.productQuantity = cartSession.items.find(y => y.productId === x.id).quantity;
              });
              this.cartProducts = response;
              if (removeInValid) {
                this.validateCartItems(cartSession);
              }
            } else {
              let unAvailableCartItems: Item[] = [];
              unAvailableCartItems = cartSession.items;
              cartSession.items = [];
              this.shoppingCart = this._cartService.reloadCart(cartSession);
              this._appMessageService.setCartItemsCount(this.shoppingCart.itemsCount);
              this.deleteUnavailableCartItems(cartSession, unAvailableCartItems);
            }
          });
      } else if (cartSession.items.length > 0) {
        cartSession.items = orderBy(cartSession.items, ['id'], ['asc']);
        this.shoppingCart = this._cartService.reloadCart(cartSession);
        this._cacheService.set(CacheKey.CartSessionInfo, this.shoppingCart);
        this._appMessageService.setCartItemsCount(this.shoppingCart.itemsCount);
      }
    } else {
      this.shoppingCart = this._cartService.reloadCart(null);
      this._cacheService.remove(CacheKey.CartSessionInfo);
      this._appMessageService.setCartItemsCount(0);
    }
  }

  /**
   * @description Show and hide the modal popup
   * @param {boolean} show
   * @param {boolean} [fromView]
   * @memberof MiniCartComponent
   */
  showModalPopup(show: boolean, fromView?: boolean): void {
    if (show) {
      // this._commonService.jumpingScroll(show);
      this.confirmModal.show();
    } else {
      this.confirmModal.hide();
      if (fromView) {
        // will resolve the screen flickering while showing modal popup
        // this._commonService.jumpingScroll(show);
      }
    }
  }
  /**
   * validating cart items available to user level or not
   * @param  {Cart} orderCart?
   */
  private validateCartItems(orderCart?: Cart) {
    if (orderCart) {
      const unAvailableCartItems: any = [];
      if (orderCart.items && orderCart.items.length > 0) {
        orderCart.items.forEach(x => {
          const cartItem: Product = this.cartProducts.filter(y => y.id === x.productId)[0];
          if (!cartItem) {
            if (x.productId) {
              unAvailableCartItems.push(x);
            }
            orderCart.items.splice(orderCart.items.indexOf(x), 1);
          }
        });
      } else {
        orderCart.items = [];
      }
      this.updateMemberCart(orderCart, unAvailableCartItems);
    }
  }

  /**
   * update cart items to memberid of logged in user
   * @param  {Cart} orderCart
   * @param  {CartItem[]} unAvailableCartItems
   */
  private updateMemberCart(orderCart: Cart, unAvailableCartItems: Item[]) {
    this._cartService.updateCart(null, CartTypes.OrderCart, null, orderCart).subscribe((response: any) => {
      this.shoppingCart = this._cartService.reloadCart(this._cartService.reloadCartSession(this.cartProducts, response));
      if (this.shoppingCart.items && this.shoppingCart.items.length > 0) {
        this.shoppingCart.itemsCount = this.shoppingCart.count();
      }
      this._cacheService.set(CacheKey.CartSessionInfo, this.shoppingCart);
      this._appMessageService.setCartItemsCount(this.shoppingCart.itemsCount);
      this._appMessageService.setCartItemsChanges(this.shoppingCart.itemsCount);
      if (unAvailableCartItems && unAvailableCartItems.length > 0) {
        this.deleteUnavailableCartItems(orderCart, unAvailableCartItems);
      }
    });
  }

  /**
  * removing not available cart items based on logged in user
  * @param  {Cart} orderCart
  * @param  {CartItem[]} unAvailableCartItems
  */
  private deleteUnavailableCartItems(orderCart: Cart, unAvailableCartItems: Item[]) {
    if (unAvailableCartItems && unAvailableCartItems.length > 0) {
      let index = 0;
      unAvailableCartItems.forEach(x => {
        this._cartService.removeCartItem(orderCart.sessionGuid, x.id).subscribe(response => {
          index = index + 1;
          if (index === unAvailableCartItems.length) {
            this.updateCartInfo(orderCart, unAvailableCartItems);
          }
        }, error => {
          index = index + 1;
          if (index === unAvailableCartItems.length) {
            this.updateCartInfo(orderCart, unAvailableCartItems);
          }
        });
      });
    }
  }

  /**
  * @description
  * @date 2018-10-24
  * @param {Cart} orderCart
  * @param {Item[]} unAvailableCartItems
  * @param {number} cartType
  * @memberof MiniCartComponent
  */
  updateCartInfo(orderCart: Cart, unAvailableCartItems: Item[]): void {
    this._cartService.getCartSessionInfo(orderCart.sessionGuid, CartTypes.OrderCart).subscribe((cart: Cart) => {
      this._cacheService.set(CacheKey.CartSessionInfo, cart);
      this.getCartItems(cart, true, true);
      this._appMessageService.setCartItemsChanges(this.shoppingCart.itemsCount);
    });
  }

  /**
 * removing product from mini cart
 * @param  {string} index
 */
  removeFromCart(productId: number) {
    const cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (cartSessionInfo && cartSessionInfo.items.length > 0) {
      const cartItem: Item = cartSessionInfo.items.find(x => x.id === productId);
      cartSessionInfo.items = remove(cartSessionInfo.items, function (n) {
        return n.id !== productId;
      });
      this._cartService
        .removeCartItem(cartSessionInfo.sessionGuid, cartItem.id)
        .subscribe((response: any) => {
          if (response) {
            this.shoppingCart = this._cartService.reloadCart(cartSessionInfo);
            this.isCartEmpty();
            this._cacheService.set(CacheKey.CartSessionInfo, this.shoppingCart);
            this._appMessageService.setCartItemsCount(this.shoppingCart.itemsCount);
            this._appMessageService.setCartItemsChanges(this.shoppingCart.itemsCount);
            if (userInfo) {
              const hasCartItems = (this.shoppingCart && this.shoppingCart.items && this.shoppingCart.items.length > 0) ? true : false;
              if (!hasCartItems) {
                this.cookieService.delete(CacheKey.hasCartItems, environment.cookiePath, environment.cookieDomain);
              }
            }
          }
        }, (error: any) => {
        });
    }
  }
  /**
   * Show the modal popup on deleting cart items
   */
  showConfirmModal(product: Product) {
    this.removeItem = true;
    this.clearBag = false;
    this.showModalPopup(true);
    this.itemToRemove = product;
  }

  /**
   * Remove the Cart Item from the minicart.
   * @param  {boolean} isConfirm
   * @param  {number} productId
   */
  confirm(isConfirm: boolean, productId?: number) {
    if (isConfirm && productId !== undefined) {
      this.removeFromCart(productId);
      this.itemToRemove = undefined;
    }
    this.showModalPopup(false);
  }

  /**
  * @returns void
  */
  miniCartBackdropClick(event: Event): void {
    this.showChange.emit(false);
  }

  /**
   * redirect to Shop cart
   */
  gotoShopCart() {
    let redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/cart';
    const localStorageCartSessionInfo = this._cacheService.get(CacheKey.CartSessionInfo);
    const cookieCartSessionGuid = this._cacheService.getCookieValue(CacheKey.CartSessionGuid);
    if (localStorageCartSessionInfo && localStorageCartSessionInfo.sessionGuid && !cookieCartSessionGuid) {
      this._cacheService.setCookieValue(CacheKey.CartSessionGuid, localStorageCartSessionInfo.sessionGuid);
    }
    redirectUrl = this._commonService.appendFBOID(redirectUrl);
    window.open(redirectUrl, '_self');
  }

  /**
   * redirect to checkout flow
   */
  goToCheckout() {
    this.showMiniCart(false);
    this._commonService.updateCountryCodeinCookie();
    const localStorageCartSessionInfo = this._cacheService.get(CacheKey.CartSessionInfo);
    const cookieCartSessionGuid = this._cacheService.getCookieValue(CacheKey.CartSessionGuid);
    if (localStorageCartSessionInfo && localStorageCartSessionInfo.sessionGuid && !cookieCartSessionGuid) {
      this._cacheService.setCookieValue(CacheKey.CartSessionGuid, localStorageCartSessionInfo.sessionGuid);
    }
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo) {
      let redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase()
        + '/' + this.languageCode.toLowerCase() + '/checkout/shipping';
      redirectUrl = this._commonService.appendFBOID(redirectUrl);
      window.open(redirectUrl, '_self');
    } else {
      this._cacheService.set(CacheKey.NavigateToShopCheckout, '/' + this.isoCountryCode.toLowerCase()
        + '/' + this.languageCode.toLowerCase() + '/checkout/shipping');
      let redirectURL = SSO.getSSOLoginUrl(this.languageCode, localStorageCartSessionInfo.sessionGuid);
      redirectURL = redirectURL + SSO.getCheckLoginFlags();
      window.location.href = redirectURL;
    }
  }
  /**
   * Goto product detail page
   * @param  {any} product
   * @returns void
   */
  navigateToProductDetail(product: Product): void {
    let selectedCategory;
    if (product.categories) {
      selectedCategory = product.categories[0];
    }
    let redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' +
    this.languageCode.toLowerCase() + '/products/' + product.slug;
    if (selectedCategory) {
      this._cacheService.set(CacheKey.SelectedCategoryState, selectedCategory);
      if (selectedCategory.slug) {
        redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/'
          + this.languageCode.toLowerCase() + '/products/' + selectedCategory.slug + '/' + product.slug;
      }
    }
    redirectUrl = this._commonService.appendFBOID(redirectUrl);
    window.location.href = redirectUrl;
    this.showMiniCart(false);
  }

  showMiniCart(isOpen: boolean) {
    this.show = isOpen;
    this.showChange.emit(isOpen);
  }
  isMobileDevice(): boolean {
    return this._commonService.isMobileDevice();
  }

  /**
   * Confirmation poup to clear cart
   * @param  {any} event
   */
  clearCart(event: Event) {
    this.removeItem = false;
    this.clearBag = true;
    this.showModalPopup(true);
  }

  /**
   * To remove all the items from cart
   * @param  {boolean} isConfirm
   */
  confirmToRemoveCart(isConfirm: boolean) {
    if (isConfirm) {
      const cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
      const sessionGuid = cartSessionInfo.sessionGuid;
      this._cartService
        .removeCart(sessionGuid)
        .subscribe((response: any) => {
          if (response) {
            this._cacheService.remove(CacheKey.CartSessionInfo);
            this._cacheService.setCookieValue(CacheKey.ClearCart, 'true');
            this._appMessageService.setCartItemsCount(0);
            this._appMessageService.setCartItemsChanges(0);
            this.shoppingCart = this._cartService.reloadCart(null);
            this.isCartEmpty();
            this.cookieService.delete(CacheKey.hasCartItems, environment.cookiePath, environment.cookieDomain);
          }
          setTimeout(() => {
            const loadCartSession = {
              sessionInfo: sessionGuid,
              reloadMemberCart: false
            };
            this._appMessageService.setMiniCart(loadCartSession);
          }, 500);
          this.showModalPopup(false);
        });
      this.showChange.emit(true);
    }
    this.showModalPopup(false);
  }


  ngOnDestroy() {
    // To avoid MemoryLeaks need to unsubscribe.
    this.miniCartSubscription.unsubscribe();
  }
}
